<template>
    <div class="sub-menu-date-w" :class="{'zaopan': int_marketToggle == 2 && !isOtr}" v-if="false">
        <div class="sport-m-container effect shadow-down" :class="{'zaopan': int_marketToggle == 2 && !isOtr}">
            <div class="s-menu-container flex">
                <!-- <template v-if="promotionRulesShow && promotionRulesShow != null">
                    <div class="sport-menu-item flex justify-center current promotion_header" @click.prevent="showPromoDetails('promotion')">
                        <div class="inner-w flex justify-between items-center">
                            <div class="promotion_header_img"></div>
                            <div class="s-w-i-title">{{arr_lang.promotion['promotion.promotion_header']}}</div>
                        </div>
                    </div>
                </template>
                <div class="sport-menu-item flex justify-center" :class="{'current':arr_selectedTemplate.sportId == 'G98'}" @click="changeSport('G98')" v-if="int_marketToggle == 3">
                    <div class="inner-w flex justify-between items-center">
                        <div></div>
                        <div class="sport-w-icon">
                            <span class="sport-icon-wrap" :class="{'focus-d':arr_selectedTemplate.sportId!='G98', 'focus-a':arr_selectedTemplate.sportId=='G98'}"></span>
                        </div>
                        <div class="s-w-i-title">{{arr_lang.AnnouncementsLang['ANNOUNCEMENTS.ALL']}}</div>
                    </div>
                </div> -->
                <!--div class="sport-menu-item flex justify-center" :class="{'current':arr_selectedTemplate.sportId == 'N1' }" @click="changeSportEdition('N1','3')" v-if="checkSportCount('N1') && !isOtr" >
                    <div class="inner-w flex justify-between items-center">
                        <div></div>
                        <div class="sport-w-icon">
                            <span class="sport-icon-wrap ssc" :class="[{'focus-a':arr_selectedTemplate.sportId=='N1' && editionStand == 3 }]"></span>
                            <div class="sport-match-count">{{ modifySportCount('N1', int_marketToggle) }}</div>
                        </div>
                        <div class="s-w-i-title">{{arr_lang.configLang['CONFIG_LANG.LBL_SIMPLE_SOCCER']}}</div>
                    </div>
                </div-->
                <!-- <template v-if="arr_selectedTemplate.templateId == 21">
                    <div class="sport-menu-item flex justify-center" :class="{'current':arr_selectedTemplate.sportId == 'N1'}" @click="changeSport('N1')" v-if="checkSportCount('N1')">
                        <div class="inner-w flex justify-between items-center">
                            <div class="sport-w-icon">
                                <span class="sport-icon-wrap s5" :class="[{'focus-d':arr_selectedTemplate.sportId!='N1', 'focus-a':(arr_selectedTemplate.sportId=='N1'||arr_selectedTemplate.sportId=='G98')}]"></span>
                            </div>
                            <div class="s-w-i-title">{{ arr_lang.configLang['CONFIG_LANG.LBL_SOCCER'] }}</div>
                        </div>
                    </div>
                    <div class="sport-menu-item flex justify-center" :class="{'current':arr_selectedTemplate.sportId == 'N2'}" @click="changeSport('N2')" v-if="checkSportCount('N2')">
                        <div class="inner-w flex justify-between items-center">
                            <div class="sport-w-icon">
                                <span class="sport-icon-wrap s7" :class="[{'focus-d':arr_selectedTemplate.sportId!='N2', 'focus-a':arr_selectedTemplate.sportId=='N2'||arr_selectedTemplate.sportId=='G98'}]"></span>
                            </div>
                            <div class="s-w-i-title">{{ arr_lang.configLang['CONFIG_LANG.LBL_BASKETBALL'] }}</div>
                        </div>
                    </div>
                </template>
                <template v-else-if="arr_selectedTemplate.templateId == 7">
                    <template v-for="(sport, key) in titleSport">
                        <div class="sport-menu-item flex justify-center" :class="{'current':arr_selectedTemplate.sportId == sport.id}" @click="changeSport(sport.id)" >
                            <div class="inner-w flex justify-between items-center">
                                <div class="sport-w-icon">
                                    <span class="sport-icon-wrap" :class="[{'focus-d':arr_selectedTemplate.sportId!=sport.id, 'focus-a':arr_selectedTemplate.sportId==sport.id  ||arr_selectedTemplate.sportId=='G98'}, sport.icon]"></span>
                                </div>
                                <div class="s-w-i-title">{{ arr_lang.configLang[sport.titleLang] }}</div>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-else> -->
                    <template v-for="(sport, key) in titleSport">
                        <div class="sport-menu-item flex justify-center" :class="{'current':arr_selectedTemplate.sportId == sport.id}" @click="changeSport(sport.id)" v-if="checkSportCount(sport.id) && ['N1','N2'].includes(sport.id)">
                            <div class="inner-w flex justify-between items-center">
                                <div class="sport-w-icon">
                                    <span class="sport-icon-wrap" :class="[{'focus-d':arr_selectedTemplate.sportId!=sport.id, 'focus-a':arr_selectedTemplate.sportId==sport.id ||arr_selectedTemplate.sportId=='G98'}, sport.icon]"></span>
                                </div>
                                <div class="s-w-i-title">{{ arr_lang.configLang[sport.titleLang] }}</div>
                            </div>
                        </div>
                    </template>
                <!-- </template> -->
                <div class="sport-menu-item flex justify-center current" @click="filterLeague(lge.lgeid)"v-for="(lge,key) in popularLeagues">
                    <div class="inner-w flex justify-between items-center">
                        <div class="sport-w-icon">
                            <img src="assets/images/england_logo.svg" class="side-img">
                        </div>
                        <div class="s-w-i-title">{{ lge.name }}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="d-c-wrapper" v-if="showCalendarBox">
                <div class="date-container">
                    <div class="date-menu-item" :class="{'focus': int_selectedParlayDate == '99'}" @click="changeEarlyParlayDate(99)">
                        <div>{{ sportTableLang['SPORT_TABLE.ALL_DATES'] }}
                            <span>&nbsp;({{ totalCountByDate('ttl') }})</span>
                        </div>
                    </div>
                    <template v-for="(date, key) in arr_earlyParlayDateList">
                        <template v-if="key!=0 || arr_selectedTemplate.templateId==21">
                            <div class="date-menu-item" :class="{'focus': key == int_selectedParlayDate}" @click="changeEarlyParlayDate(key)">
                                <template v-if="cookies_lang=='zh_TW' || cookies_lang == 'zh_CN'">
                                    <div>{{ date | date('MM/DD') }}
                                        <span>&nbsp;({{ totalCountByDate(key) }})</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div>{{ date | date('DD/MM') }}
                                        <span>&nbsp;({{ totalCountByDate(key) }})</span>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </template>
                    <div class="date-menu-item" :class="{'focus': int_selectedParlayDate == '8'}" @click="changeEarlyParlayDate(8)">
                        <div>{{ sportTableLang['SPORT_TABLE.FUTURE'] }}
                            <span>&nbsp;({{ totalCountByDate(8) }})</span>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
  import {
    mapGetters
  } from 'vuex'
  import EventBus from '@/vue/events/event-bus'
  import moment from 'moment'
  import vueCookie from 'vue-cookie'
//   import gameBanner from '../home/gameBanner'

  export default {
    components:{
        EventBus,
        // gameBanner,
    },
    computed:{
        ...mapGetters([
            'int_marketToggle',
            'arr_selectedTemplate',
            'arr_sportList',
            'arr_lang',
            'arr_sportAll',
            'arr_sportCountMarket',
            'showCalendarBox',
            'arr_earlyParlayDateList',
            'sportTableLang',
            'int_selectedParlayDate',
            'arr_earlyEventCountByDate',
            'loadGameHeader',
            'titleSport',
            'parlaySportList',
            'isOtr',
            'sportBettypeList',
            'editionStand',
			'previous_edition',
            'isParlay',
        ])
    },
    data() {
        return {
            cookies_lang: window._cookie,
            promotionRulesShow:window.promotionRulesShow,
            popularLeagues:window.popularLeagues,
        }
    },
    methods:{
        changeSport(sportId){
            this.$store.commit('SELECTED_SPORT', sportId)
            // this.$store.commit('PLAYTYPE', 1);
            this.$store.commit('SELECTED_TEMPLATE', {templateId:1})
            EventBus.$emit('changeMarketTab', 1, this.$store.getters.selected_date)
        },
        // changeSport(sportId){
        //     let Vue = this;
        //     this.$store.commit('SELECT_ALL_LEAGUE', true)
        //     this.$store.commit('FILTER_SELECT_ALL', true)
        //     this.$store.commit("GAMEBANNER_SELECTED", false);
        //     $( ".scroller" ).scrollTop( 0 );
        //     this.$store.commit('IS_HIDE_LEAGUE', false)
        //     var container = $(".sub-m-menu");
        //     var container2 = $(".sub-background");
        //     if (container || container2) {
        //         container.hide();
        //         container2.hide();
        //     }
        //     if(sportId!='N1'&&sportId!='G98'){
        //         if(Vue.$store.getters.simDisp == '4' || Vue.$store.getters.simDisp == '6'){
        //             Vue.$store.commit('SIM_DISP',1)
        //             // vueCookie.set('simDisp', 1)
        //             localStorage.setItem('simDisp', 1)
        //         }
        //     }

        //     if(this.editionStand=='3'){
        //         this.$store.commit('EDITIONSTAND', this.previous_edition)
        //         this.$store.commit('SC_CS_HIDE', {}) 
        //     }else{
        //         this.$store.commit('SET_SUBMENU_STATUS', {})
        //     }
	    //     this.$store.commit('SHOW_FLOATING', false)
        //     $( ".scroll" ).scrollTop( 0 );
        //     this.$store.commit('VIRTUAL_DATA_LIST', [])
        //     this.$store.commit('LOADGAMEHEADER', false)
        //     // this.$store.commit('LOADINGSCREEN',true)
        //     this.$store.commit('EVENTLIST', [])
        //     this.$store.commit('TODAYRBEVENTLIST', [])
        //     this.$store.commit('SWIPE_MODE', 1)
        //     this.$store.commit('SET_SUBMENU_STATUS', {})
        //     $('.odd-t-i-wrapper').removeClass('status2') // swipe right
        //     $('.standard-odd-l-w').removeClass('status2')
        //     this.$store.commit('SORTEDEVENTLIST', [])
        //     this.$store.commit('COOKIE_LEAGUE', {
        //         remove : true,
        //     })
        //     if(this.arr_selectedTemplate.templateId == 21){
        //         EventBus.$emit('parlaySportTemplate', sportId)
        //     }else{
        //         EventBus.$emit('sportTemplate', sportId)
        //     }
        // },

        changeSportEdition(sportId, edition){
            let Vue = this;
            this.$store.commit("GAMEBANNER_SELECTED", false);
            $( ".scroller" ).scrollTop( 0 );
            this.$store.commit('IS_HIDE_LEAGUE', false)
            var container = $(".sub-m-menu");
            var container2 = $(".sub-background");
            if (container || container2) {
                container.hide();
                container2.hide();
            }
            /*
            if(sportId!='N1'&&sportId!='G98'){
                if(Vue.$store.getters.simDisp == '4' || Vue.$store.getters.simDisp == '6'){
                    Vue.$store.commit('SIM_DISP',1)
                    // vueCookie.set('simDisp', 1)
                    localStorage.setItem('simDisp', 1)
                }
            }*/
	        this.$store.commit('SHOW_FLOATING', false)
            $( ".scroll" ).scrollTop( 0 );
            this.$store.commit('VIRTUAL_DATA_LIST', [])
            this.$store.commit('LOADGAMEHEADER', false)
            // this.$store.commit('LOADINGSCREEN',true)
            this.$store.commit('EVENTLIST', [])
            this.$store.commit('TODAYRBEVENTLIST', [])
            this.$store.commit('SWIPE_MODE', 1)
            $('.odd-t-i-wrapper').removeClass('status2') // swipe right
            $('.standard-odd-l-w').removeClass('status2')
            this.$store.commit('SORTEDEVENTLIST', [])
            this.$store.commit('SET_SUBMENU_STATUS', {})
            this.$store.commit('COOKIE_LEAGUE', {
                remove : true,
            })
            this.$store.commit('EDITIONSTAND', edition)
            if(this.arr_selectedTemplate.templateId == 21){
                EventBus.$emit('parlaySportTemplate', sportId)
            }else{
                EventBus.$emit('sportTemplate', sportId)
            }
        },
        modifySportCount(sprtId, market){
            
            let Vue = this
            let count = []
            let sid = []

            let sportList = Vue.arr_sportCountMarket
            let earlyCount = this.$store.getters.arr_earlyEventCountByDate

            if(sprtId == 'N1' || sprtId == 'ALL'){
                sid.push('1')
            }
            if(sprtId == 'N2' || sprtId == 'ALL'){
                sid.push('2')
            }
            if(sprtId == 'N13' || sprtId == 'ALL'){
                sid.push('13')
            }
            if(sprtId == 'N3' || sprtId == 'ALL'){
                sid.push('3')
            }
            if(sprtId == 'N21' || sprtId == 'ALL'){
                sid.push('21')
            }
            if(sprtId == 'N12' || sprtId == 'ALL'){
                sid.push('12')
            }
            if(sprtId == 'N24' || sprtId == 'ALL'){
                sid.push('24')
            }
            if(sprtId == 'N23' || sprtId == 'ALL'){
                sid.push('23')
            }
            if(sprtId == 'N15' || sprtId == 'ALL'){
                sid.push('15')
            }
            if(sprtId == 'N7' || sprtId == 'ALL'){
                sid.push('7')
            }
            if(sprtId == 'N14' || sprtId == 'ALL'){
                sid.push('14')
            }
            if(sprtId == 'N19' || sprtId == 'ALL'){
                sid.push('19')
            }
            if(sprtId == 'N20' || sprtId == 'ALL'){
                sid.push('20')
            }
            if(market==1){
                $.each(sportList['live'], function(sport, val){
                    if(_.includes(sid, sport)){
                        count.push(val)
                    }
                })
                $.each(sportList['today'], function(sport, val){
                    if(_.includes(sid, sport)){
                        count.push(val)
                    }
                })
            }else if(market==2){
                if(this.$store.getters.arr_selectedTemplate.subTemplateId=='3'){
                    $.each(sportList['otr'], function(sport, val){
                        if(_.includes(sid, sport)){
                            count.push(val)
                        }
                    })
                }else{
                    $.each(sportList['early'], function(sport, val){
                        if(_.includes(sid, sport)){
                            count.push(val)
                        }
                    })
                    /*
                    $.each(earlyCount, function(sport, val){
                        if(_.includes(sid, sport)){
                            count.push(val['ttl'])
                        }
                    })*/
                }
            }else if(market==3){
                $.each(sportList['live'], function(sport, val){
                    if(_.includes(sid, sport)){
                        count.push(val)
                    }
                })
            }

            return _.sum(count)
        },
        checkSportCount(sprtId){
            return true
            // check have match count only show sport in header
            let Vue = this
            
            let sptCount = Vue.arr_sportCountMarket
            let market = Vue.arr_selectedTemplate.int_marketToggle
            let earlyCount = this.$store.getters.arr_earlyEventCountByDate
            let spt = []
            let havCount = false

            _.forEach(this.titleSport, function(tsVal, tsKey){
                if(tsVal.id == sprtId){
                    spt = tsVal.sid
                }
            })
            
            if(Object.keys(sptCount).length >0){
                _.forEach(spt, function(sptid) {
                    if(market == 1){
                        if(sptCount['live'] && sptCount['live'][sptid]){
                            havCount = true
                            return true
                        }
                        if(sptCount['today'] && sptCount['today'][sptid]){
                            havCount = true
                            return true
                        }
                        if(!sptCount['today'] && !sptCount['live'] &&  sptid==1){
                            havCount = true
                            return true
                        }
                    }else if(market == 2){
                        if(Vue.$store.getters.arr_selectedTemplate.subTemplateId=='3'){
                            if(sptCount['otr'] && sptCount['otr'][sptid]){
                                havCount = true
                                return true
                            }    
                        }else{
                            if(sptCount['early'] && sptCount['early'][sptid]){
                                havCount = true
                                return true
                            }
                            if(Vue.$store.getters.arr_selectedTemplate.templateId==21){
                                if(sptCount['today'] && sptCount['today'][sptid]){
                                    havCount = true
                                    return true
                                }
                            }
                        }
                        if((!sptCount['today'] && !sptCount['early']) &&  sptid==1){
                            havCount = true
                            return true
                        }
                    }else if(market == 3){
                        if(sptCount['live'] && sptCount['live'][sptid]){
                            havCount = true
                            return true
                        }
                        if(!sptCount['live'] &&  sptid==1){
                            havCount = true
                            return true
                        }
                    }
                })
            }
            
            if(havCount){
                if(this.loadGameHeader){
                    this.checkDefaultMatches()
                }
                /*
                if(this.loadGameHeader){
                    
                    if(Vue.$store.getters.arr_selectedTemplate.templateId==21){
                        if(Vue.$store.getters.arr_selectedTemplate.sportId != sprtId){
                            Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sprtId)
                            Vue.changeSport(sprtId)
                        }
                    }else{
                        var sport = _.keys(this.arr_sportList)
                        sport = sport[0]
                        if(_.includes(spt, sport) && Vue.$store.getters.arr_selectedTemplate.sportId != sprtId){
                            Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sprtId)
                            Vue.changeSport(sprtId)
                        }
                    }
                    return true 
                }*/
                return true
            }else{
                return false
            }
        },
        checkDefaultMatches(){
            let Vue = this
            
            let sptCount = Vue.arr_sportCountMarket
            let market = Vue.arr_selectedTemplate.int_marketToggle
            let spt = []
            let sptidSelect="";
            if(window.sprtid != '') {
                const index = this.$store.getters.sportList.findIndex(item => item.sprtId === 'N'+window.sprtid)
                if(index !== -1){
                    sptidSelect = 'N' + window.sprtid;
                }
            }
            let getSport = _.filter(this.$store.getters.titleSport, function(x){
                if(!_.isUndefined(account.default['def_sprt']) && account.default['def_sprt']!= null){
                    if(x.sid.toString() == account.default['def_sprt'].toString()){
                        sptidSelect = x.id
                    }
                }
            })
            let havCount = false
            _.forEach(this.titleSport, function(tsVal, tsKey){
                spt.push(tsVal.sid)
            })
            
            if(Object.keys(sptCount).length >0){
                _.forEach(spt, function(sptid) {
                    if(market == 1){
                        if(sptCount['live'] && sptCount['live'][sptid]){
                            havCount = true
                        }
                        if(sptCount['today'] && sptCount['today'][sptid]){
                            havCount = true
                        }
                    }else if(market == 2){
                        if(Vue.$store.getters.arr_selectedTemplate.subTemplateId=='3'){
                            if(sptCount['otr'] && sptCount['otr'][sptid]){
                                havCount = true
                            }    
                        }else{
                            if(sptCount['early'] && sptCount['early'][sptid]){
                                havCount = true
                            }
                            if(Vue.$store.getters.arr_selectedTemplate.templateId==21){
                                if(sptCount['today'] && sptCount['today'][sptid]){
                                    havCount = true
                                }
                            }
                        }
                    }else if(market == 3){
                        if(sptCount['live'] && sptCount['live'][sptid]){
                            havCount = true
                        }
                        if(!sptCount['live'] &&  sptid==1){
                            havCount = true
                        }
                    }
                    let sprtid_str = "N"+sptid
                    if(havCount==false && sptidSelect==sprtid_str) {
                        sptidSelect = ""
                    }
                    if(havCount==true && sptidSelect==""){
                        sptidSelect=sprtid_str;
                    }
                })
            }
            
            if(sptidSelect!=''){
                if(this.loadGameHeader){
                    if(Vue.$store.getters.arr_selectedTemplate.templateId==21){
                        if(Vue.$store.getters.arr_selectedTemplate.sportId != sptidSelect){
                            Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sptidSelect)
                            Vue.changeSport(sptidSelect)
                        }
                    }else{
                        if( Vue.$store.getters.arr_selectedTemplate.sportId != sptidSelect){
                            Vue.$set(Vue.$store.getters.arr_selectedTemplate, 'sportId', sptidSelect)
                            Vue.changeSport(sptidSelect)
                        }
                    }
                }
            }
        },
        changeEarlyParlayDate(datekey){
            $( ".scroller" ).scrollTop( 0 );
            this.$store.commit('SELECT_ALL_LEAGUE', true)
            this.$store.commit('FILTER_SELECT_ALL', true)
            this.$store.commit('TODAYRBEVENTLIST', [])
            this.$store.commit('SORTEDEVENTLIST', [])
            this.$store.commit('SORTEDTODAYRBEVENTLIST', [])
            this.$store.commit('SELECTED_PAYLAY_DATE', datekey)
            if(this.editionStand=='3'){
                this.$store.commit('SC_CS_HIDE', {}) 
            }else{
                this.$store.commit('SET_SUBMENU_STATUS', {})
            }
            if(this.isParlay && window.allowRbParlay && (datekey == 99 || datekey == 0)) {
                this.$store.dispatch('getTodayRBSportOdds', {
                    loading:0,
                    token: token.arr_6
                })
            } else {
                this.$store.dispatch('getSportOdds', {
                    loading:0,
                    token: token.arr_6
                })
            }
        },
        totalCountByDate(date){
            let currectSport = this.$store.getters.arr_selectedTemplate.sportId
            let sportId = ''
            let sid = []
            let totalCount = 0
            let allDateCount = this.$store.getters.arr_earlyEventCountByDate

            if(currectSport == 'N1'){
                sid.push('1')
            }else if(currectSport == 'N2'){
                sid.push('2')
            }else if(currectSport == 'N13'){
                sid.push('13')
            }else if(currectSport == 'N3'){
                sid.push('3')
            }else if(currectSport == 'N21'){
                sid.push('21')
            }else if(currectSport == 'N12'){
                sid.push('12')
            }else if(currectSport == 'N24'){
                sid.push('24')
            }else if(currectSport == 'N23'){
                sid.push('23')
            }else if(currectSport == 'N15'){
                sid.push('15')
            }else if(currectSport == 'N7'){
                sid.push('7')
            }else if(currectSport == 'N14'){
                sid.push('14')
            }else if(currectSport == 'N19'){
                sid.push('19')
            }else if(currectSport == 'N20'){
                sid.push('20')
	    }else if(currectSport == 'N23'){
                sid.push('23')
            }

            _.forEach(sid, function(sval){
                totalCount = allDateCount[sval] && allDateCount[sval][date] ? allDateCount[sval][date] : 0
            })

            return totalCount
        },
        getEarlyCountByDate(){
            this.$store.dispatch('getEarlyEventCountByDate');
        },
        showPromoDetails(){
            EventBus.$emit('SHOW_PROMO_DETAILS', true)
        },
        filterLeague(lge) {
            EventBus.$emit('filterLeague', lge)
        }
    },
    mounted(){
        // this.getEarlyCountByDate()
        EventBus.$off('CHANGE_SPORT')
        EventBus.$on('CHANGE_SPORT', ((sportId) => {
          this.changeSport(sportId)
        }).bind(this))
        EventBus.$on('getSimpleSoccer', ((sportid, edition) => {
            this.changeSportEdition(sportid, edition)
        }).bind(this))
        EventBus.$on('changeEarlyParlayDate', ((dt) => {
            console.log('changeEarlyParlayDate: '+dt)
            this.changeEarlyParlayDate(dt)
        }).bind(this))
    },
  }
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// resources/score/vue/apps/home/gameHeader.vue